/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState,useEffect,useRef } from "react";
import { Rnd } from 'react-rnd';
import { useTranslation } from 'react-i18next';
import {DFPAPIEndpointGalley } from "../../../utils/axios";
import '../../../assets/styles//styles.scss';
import '../../../assets/styles/modal.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../assets/styles/styles.scss';
import minus from '../../../images/icons/minusgaly.png';
import minusTot from '../../../images/icons/minusbay.png';
import plus from '../../../images/icons/plus.png';
import usePermissions from "../../../utils/userPermissions";
import useAccountDomain from '../../../utils/useAccountDomain';
import frontGalleyG1G2 from '../../../assets/images/frontGalleyG1G2.png';
import rearGalleyG4E from '../../../assets/images/rearGalleyG4E.png';
import lateralGalley from '../../../assets/images/lateralGalley.png';
import LoadingGIF from '../../../assets/loadingIn.gif';
import { MdOutlineAddRoad } from "react-icons/md";
import useToastAssist from '../../../utils/useToastAssist';
import { GalleyLoadingModal } from './galleyLoadingModal';
import CustomSelect from "../../../common/CustomSelect";

const resolveGalleyLayoutImage = (galley, fallbackName = '') => {
  const name = String(galley?.name || fallbackName || '').toLowerCase();
  const position = String(galley?.position?.code || galley?.position || '').toLowerCase();

  if (/g4|rear|\baft\b/.test(name)) return rearGalleyG4E;
  if (/g1|g2|front|\bfwd\b/.test(name)) return frontGalleyG1G2;
  if (/lateral|g3|middle|\bmid\b/.test(name)) return lateralGalley;

  if (position === 'aft' || position.includes('aft')) return rearGalleyG4E;
  if (position === 'fwd' || position.includes('fwd')) return frontGalleyG1G2;
  if (position === 'mid' || position.includes('mid')) return lateralGalley;

  return lateralGalley;
};

const EditFormFields = [
  {label: 'ID', attribute: 'trolleyNo', type: 'text', disabled: false, },
  {key: 1, label: 'Trolley Items', attribute: 'trolleyItem', name: 'trolleyItem', type: 'selectSearch'
        , defaultValue: ''
        , value: ''
        , className: 'select-search-cls'
        , options: []
        , multiple: true
        , search: true
        , autoComplete: 'on'
        , autoFocus: false
        , disabled: false, placeholder: 'Items'
    }
];

export const StandardGalleyLoading = ({
  initialAircraftId,
  galleyId,
  galleyName,
  selectedAircraft,
  onClose,
  onSaveSuccess,
  isOpen = true
}) => {

  const { ready } = useTranslation();
  const [toggleState, setToggleState] = useState(null);
  const [galleyIndex, setGalleyIndex] = useState(null);
  const [initTab,setInitTab]=useState(null);
   const [resolvedCartOptions, setResolvedCartOptions] = useState(null);
    const [cartsLimitMessage,setCartsLimitMessage] = useState(null);
  const [airCraftLoadingSel,setAircraftLoadingSel]=useState({key:'',galley:'',businessclassName:false,economy:false,premEconomy:false})
  const [ selectedGalley, setSelectedGalley ] = useState({})
  const [galleyDetails, setGalleyDetails] = useState([]);
  const [aircraftOptions, setAircraftOptions] = useState({});
  const [galleyArr, setGalleyArr] = useState([]);
  const [galleyCarts, setGalleyCarts] = useState([]);
  const [galleyCartsDet, setGalleyCartsDet] = useState([]);
  const [cartsStatus,setCartsStatus]=useState({fullCart:0,halfCart:0,smu:0,stowage:0});
    const [cartsCheck,setCartsCheck]=useState({fullCart:0,halfCart:0,smu:0,stowage:0});
  const [cartsGalleyLoading, setCartsGalleyLoading] = useState([]);
  const [galleyItems,setGalleyItems]=useState([]);
  const [galleyLoadingMessage,setGalleyLoadinMessage]=useState({});
  const [saveGalley,setSaveGalley]=useState(false);
  const [saveAlert,setSaveAlert]=useState({action:false,index:null,cancel:false});
  const [trolleyItems,setTrolleyItems]=useState([]);
  const [editGalley,setEditgalley]=useState({});
  const [cartsCon,setCartsCon]=useState([]);
  const [showAddTrolley,setShowAddTrolley]=useState({trolleyNo:""});
  const [boxes, setBoxes] = useState([]);
  const [cartsMax,setCartsMax]=useState([]);
  const [,setTrolleyCheck]=useState({});
  const [imageGalley,setImageGalley]=useState(null);
  const [galleyBoxes, setGalleyBoxes] = useState([]);
  const [titleEdit, setTitleEdit] = useState('Update Galley Details');
  const [displayItems, setDisplayItems] = useState([]);
  const [boxId, setBoxId] = useState(null);
 const [autoSelectGalley, setAutoSelectGalley] = useState(null);
  const [aircraftSwitchToken, setAircraftSwitchToken] = useState(0);
  const {toastError,toastSuccess} = useToastAssist();
  const [newBayName, setNewBayName] = useState('');
  const [newBayCartOptions, setNewBayCartOptions] = useState('1');
  const imageContainerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });


  const [deletedBayIds, setDeletedBayIds] = useState([]);
  const [deletedTrolleyIds, setDeletedTrolleyIds] = useState([]); 
  const [isSaving, setIsSaving] = useState(false);
  const [galleyBayAreasRaw, setGalleyBayAreasRaw] = useState([]);

  const pctToPx = (pct, total) => (Number(pct || 0) / 100) * total;
  const pxToPct = (px, total) => (total ? (px / total) * 100 : 0);

  const cartOptionsFromBoxType = (type) => {
    if (type === 'smu') return '1';
    if (type === 'full' || type === 'half') return '2';
    return '0';
  };

  useEffect(() => {
    const updateContainerSize = () => {
      if (imageContainerRef.current) {
        setContainerSize({
          width: imageContainerRef.current.offsetWidth,
          height: imageContainerRef.current.offsetHeight,
        });
      }
    };
    updateContainerSize();
    window.addEventListener('resize', updateContainerSize);
    return () => window.removeEventListener('resize', updateContainerSize);
  }, [imageGalley]);

  const handleCreateBay = () => {
    const name = newBayName.trim();
    if (!name || !createGalleyDesign) return;
    const id = `new_bay_${Date.now()}`;
    setGalleyBoxes((prev) => [
      ...prev,
      {
        id,
        isNew: true,
        name,
        cartOptions: newBayCartOptions,
        xPct: 8,
        yPct: 8,
        widthPct: 25,
        heightPct: newBayCartOptions === '1' ? 25 : 50,
      },
    ]);
    setNewBayName('');
  };

  const handleRemoveBay = (id) => {
    if (!deleteGalleyDesign) return;
    const bay = galleyBoxes.find((b) => b.id === id);

    if (bay && !bay.isNew) {
      setDeletedBayIds((prev) => [...prev, id]);
    }
    setGalleyBoxes((prev) => prev.filter((b) => b.id !== id));
    setBoxes((prev) => prev.filter((b) => b.boxId !== id));
  };

  const updateBayGeometry = (id, geometryPx) => {
    const { width, height } = containerSize;
    if (!width || !height) return;
    setGalleyBoxes((prev) =>
      prev.map((b) =>
        b.id === id
          ? {
              ...b,
              xPct: pxToPct(geometryPx.x, width),
              yPct: pxToPct(geometryPx.y, height),
              widthPct: pxToPct(geometryPx.width, width),
              heightPct: pxToPct(geometryPx.height, height),
            }
          : b
      )
    );
  };


  const domainNGo = useAccountDomain();

  const { hasPermission: createGalleyDesign } = usePermissions('create', "configuration.lcc.galley-design");
  const { hasPermission: editGalleyDesign } = usePermissions('edit', "configuration.lcc.galley-design");
  const { hasPermission: deleteGalleyDesign } = usePermissions('delete', "configuration.lcc.galley-design");
  const { hasPermission: viewDetailsGalleyDesign } = usePermissions('view', "configuration.lcc.galley-design");

  const getGalleyLists=(gl)=>{
    let galleyNames=[]
      if(gl.length){
      galleyNames = gl.reduce(
      (acc, item,index) =>[
      ...acc,
      { key: index + 1, label: item.name, value: item.name },

      ],
      [{ key: 0, label: "Select Galley", value: "" }]
      );
      setAircraftOptions((prev)=>{return {...prev,galleyNames}});
      }
  }

  useEffect(() => {

    fetchGalleyCatergories();
  
    if (selectedAircraft?.data) {
      setGalleyDetails([selectedAircraft.data]);
 
      const actModel = [{
        key: 1,
        label: selectedAircraft.data.key || selectedAircraft.data.code || 'Aircraft',
        value: selectedAircraft.data.key
      }];
      
      setAircraftOptions({key: actModel});
      setAircraftLoadingSel({
        key: actModel[0].label,
        galley: actModel[0].label,
        businessclassName: false,
        economy: false,
        premEconomy: false
      });
 
      if (galleyId) {
 
        setAutoSelectGalley({ id: galleyId, name: galleyName });
      }
    
      if (selectedAircraft?.data?.galleys && Array.isArray(selectedAircraft.data.galleys)) {
        setSelectedGalley(selectedAircraft.data);
        setGalleyArr(selectedAircraft.data.galleys);
        getGalleyLists(selectedAircraft.data.galleys);
      } else {
        onAircraftChange(actModel[0]);
      }
    }
  }, [selectedAircraft, initialAircraftId, galleyId, galleyName])

useEffect(() => {
 if(galleyLoadingMessage && (galleyLoadingMessage.error||galleyLoadingMessage.success)){
  galleyLoadingMessage.error ? toastError(galleyLoadingMessage.error) : toastSuccess(galleyLoadingMessage.success);
  setTimeout(()=>{
    setGalleyLoadinMessage({});
  },5000)
 }
}, [galleyLoadingMessage])

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    const objName=galleyBoxes.find(gb=>{if(gb.id===boxId){
      return gb
    }})
  if(objName&&objName?.name){
    if(boxes.find(bx=>bx.boxId===boxId)){
    const bxObj=  boxes.find(bx=>bx.boxId===boxId)
      bxObj['code']=objName.name
    }
  }
  }, [galleyBoxes,boxes])

  useEffect(() => {
    if(saveAlert.index&&!saveAlert.cancel){
      setToggleState(saveAlert.index);
      setGalleyIndex(saveAlert.index)
    }
  }, [saveAlert])

  useEffect(() => {
    if(cartsCon&&(galleyIndex||initTab)){
       const cartsPr=cartsCon?.find(fx=>{
      if (galleyIndex === null) {
        return fx.index === initTab;
      } else {
        return fx.index === galleyIndex;
      }
    })
    setCartsMax(cartsPr)
    }

  }, [galleyIndex,initTab,boxes,trolleyItems])

const verifyCartsLimit=()=>{
  let cartLenSmu=0
  let cartLenStowage=0
  let cartLenHalf=0
  let cartLenFull=0

  if(boxes && (galleyIndex||initTab)){
    boxes.forEach(bx=>{
      const {id,cartQuantityAllots}=bx;
      if(id==='smu'){
       cartLenSmu+=bx.cartQuantityAllots.length
    }
    if(id==='stowage'){
      cartLenStowage+=bx.cartQuantityAllots.length
   }
    cartQuantityAllots.forEach(caRt=>{
      if (caRt.cartType === 'fullCart') {
        cartLenFull++;
      } else if (caRt.cartType === 'halfCart') {
        cartLenHalf++;
      }
    })
  })
}
if(boxes.length===0){
  setCartsCheck((_)=>{
    const obj={..._};
    for (const key in obj) {
      obj[key] = 0;
    }
    return obj;
  })

}
setCartsCheck((_)=>{return{..._,smu:cartLenSmu,fullCart:cartLenFull,halfCart:cartLenHalf,stowage:cartLenStowage}})
}


  useEffect(() => {
    verifyCartsLimit()
  }, [boxes,galleyIndex,trolleyItems,editGalley])

useEffect(() => {
  if(galleyDetails){
    const actModel = galleyDetails.reduce(
      (acc, item, index) => [
        ...acc,
        { key: index + 1, label: `${(item?.key || item?.code || item?.id || 'Aircraft').replace(/-+/g, '-')}`, value: item?.key || item?.code || item?.id },
      ],
      [{ key: 0, label: "Select Aircraft Variant", value: "" }]
    );
    
    if(actModel.length){
      setAircraftOptions({key: actModel});
      
      if (initialAircraftId && galleyId) {
        try {
          const matchedItem = galleyDetails.find(item => item.id === initialAircraftId);
    
          if (matchedItem) {
            const selectedOption = actModel.find(option => option.value === matchedItem.key);
            
            if (selectedOption) {
              setAircraftLoadingSel({
                key: selectedOption.label,
                galley: selectedOption.label,
                businessclassName: false,
                economy: false,
                premEconomy: false
              });

              onAircraftChange(selectedOption);

              setAutoSelectGalley({ id: galleyId, name: galleyName });
              
            }
          }
        } catch (error) {
        }
      }
    }
  }
}, [galleyDetails, initialAircraftId, galleyId])

useEffect(() => {
  if (galleyArr && galleyArr.length > 0 && autoSelectGalley) {
 
    let matchedGalley = galleyArr.find(gl => gl._id === autoSelectGalley.id);
 
    if (!matchedGalley) {
      matchedGalley = galleyArr.find(gl => gl.name === autoSelectGalley.name);
 
    }
 
    if (!matchedGalley && autoSelectGalley.name) {
      matchedGalley = galleyArr.find(gl => gl.name.includes(autoSelectGalley.name));
      
    }
    
    if (matchedGalley) {
  
      setToggleState(matchedGalley.name);
      setGalleyIndex(matchedGalley.name);
      setInitTab(matchedGalley.name);
      
      setAutoSelectGalley(null);
    } else {
     
    }
  }
}, [galleyArr, autoSelectGalley])

 
useEffect(() => {
  if (galleyCarts && galleyCarts.length > 0 && (galleyIndex || initTab)) {
    
    galleyCarts?.forEach((gc) => {
      if (gc.name === (galleyIndex || initTab)) {
 
        const bayAreasRaw = gc.bayAreas || [];
        const legacyCarts = gc.carts || [];
        
        if (bayAreasRaw.length > 0) {
          setGalleyBayAreasRaw(bayAreasRaw);
          const flat = bayAreasRaw.flatMap((ba) =>
            (ba.trolleys || []).map((tr) => ({
              ...tr,
              boxId: ba._id,
              bayAreaName: ba.name,
              index: gc.name,
              isNew: false,
            }))
          );
          setGalleyCartsDet(flat);
        
        } else if (legacyCarts.length > 0) {
          const legacyPositioned = legacyCarts.filter((c) => c.boxId);
          const syntheticBayAreas = legacyPositioned.map((c) => ({
            _id: c.boxId,
            name: c.code || '',
            position: null,
            trolleys: [c],
            _legacy: true,
          }));
          setGalleyBayAreasRaw(syntheticBayAreas);
          const flat = legacyPositioned.map((c) => ({
            ...c,
            boxId: c.boxId,
            bayAreaName: c.code || '',
            index: gc.name,
            isNew: true,
          }));
          setGalleyCartsDet(flat);
        } else {
          setGalleyBayAreasRaw([]);
          setGalleyCartsDet([]);
        }
      }
    });
  }
}, [galleyCarts, galleyIndex, initTab])
 

  useEffect(() => {
    const currentIndex = galleyIndex || initTab;
    if (!currentIndex) {
      setCartsStatus({ fullCart: 0, halfCart: 0, smu: 0, stowage: 0 });
      return;
    }
    const scopedBoxes = boxes.filter((b) => b.index === currentIndex);
    const counts = { fullCart: 0, halfCart: 0, smu: 0, stowage: 0 };
    scopedBoxes.forEach((b) => {
      if (b.id === 'full') counts.fullCart++;
      else if (b.id === 'half') counts.halfCart++;
      else if (b.id === 'smu') counts.smu++;
      else if (b.id === 'stowage') counts.stowage++;
    });

    setCartsStatus({ ...counts, index: currentIndex });
    getCartDetails();
  }, [galleyCartsDet,galleyArr,saveGalley,boxes])


  const setTabColor=()=>{
    galleyArr.forEach((el) => {
      if((initTab===galleyIndex&&(el.name===initTab||el.name===galleyIndex))||(!galleyIndex&&(el.name===initTab))||(initTab!==galleyIndex&&(el.name===galleyIndex)))
      {el.saved=true}
    });
    getGalleyTabs();
    getCartDetails();
  }
  const onClickBox=(e,id)=>{
  if(!e.target.alt && e.target.tagName !== 'INPUT'){
if(boxes.find(bx=>bx?.boxId===id)===undefined){
    setShowAddTrolley({trolleyNo:id});
      const galleyObj=boxes.find(b=>b.boxId===id);
      if(galleyObj){
      setEditgalley(galleyObj)
      }
      let editAddFieldsDep=[];
     galleyItems&& galleyItems.map( (fieldValue, index) => {
      editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
      return fieldValue;
      });
      setTrolleyItems(editAddFieldsDep);

      EditFormFields.map( editRow => {

      if (editRow.attribute === 'trolleyItem' ) {
      editRow.options = trolleyItems;
      }
      return editRow;
      });
}
  }
  }


  const fetchGalleyCatergories=async()=>{
    try {
      const resp = await DFPAPIEndpointGalley.get(`galley/items/category`);
        if(resp.success){
        setGalleyItems(resp.items)
        }
        }
        catch (error) {

        }

  }

 

        const onCloseAddGalley=()=>{
          setShowAddTrolley({trolleyNo:""});
          setDisplayItems([]);
          setTitleEdit("Update Galley Details")
          setEditgalley({});
          setCartsLimitMessage(null);
          setResolvedCartOptions(null);
        }

const getItemsCart=(val)=>{
 const resp= val?.map((item,index) => {
    return {
      typeId:index+1,
      name: galleyItems?.find(i => i.name === item?.name)?.name
    }
    })
    return resp;
}


const getBoxName=()=>{
  // eslint-disable-next-line array-callback-return
  const objName=galleyBoxes.find(gb=>{if(gb.id===showAddTrolley.trolleyNo){
    return gb
  }})
 return objName.name
}

      const getCartQunatityAllots=(updated)=>{
        return [
          {
              code: generateRandomVariable()||'897GH',
              cartType: updated.cartType?updated.cartType:updated.cartOptions==='1'?'smu':'stowage',
              typesOfItems:getItemsCart(updated.cartItems),
              ...(updated.crewPositionByHalf
                ? {
                    crewPositionByHalf: updated.crewPositionByHalf,
                    crewPositions: [
                      updated.crewPositionByHalf.leftHalf || '',
                      updated.crewPositionByHalf.rightHalf || '',
                    ],
                  }
                : { crewPositions: updated.crewPositions || [] })
          }
      ]
      }

      const onSubmitGalleyBoxes=(updated)=>{
      setTrolleyCheck({cartType:updated.cartType,boxId:showAddTrolley.trolleyNo})
        const{fullCart,halfCart,smu,stowage}=updated
       const res= Object.values(cartsGalleyLoading.reduce((acc, el) => {
          el.fullCart=fullCart;
          el.halfCart=halfCart;
          el.smu=smu;
          el.stowage=stowage;
          el.index=galleyIndex||initTab
          acc[el.index] = el;
          return acc;
        }, {}));
      setCartsGalleyLoading([...res])

      const trolleyTypeId = (updated.cartOptions==='2'&&updated.cartType==='fullCart')?'full'
        :(updated.cartOptions==='2'&&updated.cartType==='halfCart')?'half'
        :updated.cartOptions==='1'?'smu':'stowage';
      const trolleyName = trolleyTypeId==='full'?'Full Cart':trolleyTypeId==='half'?'Half Cart':trolleyTypeId==='smu'?'SMU':'Misc. Stowage';
      const crewFields = updated.crewPositionByHalf
        ? { crewPositionByHalf: updated.crewPositionByHalf, crewPositions: [updated.crewPositionByHalf.leftHalf||'', updated.crewPositionByHalf.rightHalf||''] }
        : { crewPositions: updated.crewPositions || [], crewPositionByHalf: undefined };

      if(Object.keys(editGalley).length&&updated){

        setBoxes((prev) => prev.map((b) => {
          if (b._id !== editGalley._id) return b;
          return {
            ...b,
            code: updated.code || b.code,
            cartQuantityAllots: getCartQunatityAllots(updated),
            ...crewFields,
            dirty: true,
          };
        }));
        setShowAddTrolley({trolleyNo:""});
        setEditgalley({});
        return;
      }

      const bayId = showAddTrolley.trolleyNo;
      const capacityError = getBoxCapacityError(bayId, updated.cartType);
      if (capacityError) {
        setGalleyLoadinMessage({ error: capacityError });
        return;
      }

      setBoxes((currentValue) => [
        ...currentValue,
        {
          _id: `new_trolley_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
          isNew: true,
          code: getBoxName(),
          id: trolleyTypeId,
          name: trolleyName,
          quantity: 1,
          boxId: bayId,
          cartQuantityAllots: getCartQunatityAllots(updated),
          index: galleyIndex || initTab,
          imageGalley,
          ...crewFields,
        },
      ]);
      setShowAddTrolley({trolleyNo:""});
      }

      const showCartDesign=(trolleys,bayId)=>{
        if(trolleys.length){
        const cartStat=trolleys.map((c,index)=>(<>
      <div className="cart-display" title="Edit Cart" onClick={(e) => onClickEditCart(e, bayId, c._id)}>
  <div className="cart-content-scroll">
    <div className="flexRow" style={{ padding: '0.5rem' }}>
      <u className="cart-type">{c.name}</u>
      <div title ="Remove Cart" className="flexRow" style={{ marginLeft: 'auto' }}>
        <img
          className="galley-icons"
          src={minus}
          onClick={(e) => onClickRemoveCart(e, bayId, c._id)}
          alt="GalleyRemove"
        />
      </div>
    </div>
    {(() => {
      const crewPositionByHalf = c.crewPositionByHalf;
      const crewPositions = c.crewPositions || [];
      const crewLabel = crewPositionByHalf
        ? [crewPositionByHalf.leftHalf, crewPositionByHalf.rightHalf].filter(Boolean).join(' / ')
        : crewPositions.join(' / ');
      return crewLabel ? (
        <div className="crew-position-indicator textAlignCenter">
        {crewLabel}
        </div>
      ) : null;
    })()}

    <br />
    {getTrolleyItems(c.cartQuantityAllots?.[0], bayId)}
  </div>
</div>

        </>))
        return cartStat
        }

        }
const getTrolleyItems = (tr, id) => {
  if (!tr || !tr.typesOfItems?.length) return null;

  const count = tr.typesOfItems.length;
  const label = count > 1 ? 'items' : 'item';

  return (
    <div className="trolley-items-wrapper">
      <div
        className="list-items"
        style={{ lineHeight: '1.5rem',
          color: '#ffffff',
          display: 'flex',
          fontWeight: 'bold',
          justifyContent: 'center',
          cursor: 'pointer'
        }}
      >
        {`${count} ${label}`}
      </div>
      <div className="trolley-items-popup">
        <ul className="trolley-items-list">
          {tr.typesOfItems.map((item, index) => (
            <li className="box-items" key={item._id || index}>
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
    const generateRandomVariable=()=> {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var variable = '';

        for (var i = 0; i < 5; i++) {
          var randomIndex = Math.floor(Math.random() * characters.length);
          variable += characters[randomIndex];
        }

        return variable;
      }

      const getBoxCapacityError = (bayAreaId, addingCartType) => {
        if (!bayAreaId) return null;
        const siblings = boxes.filter((b) => b.boxId === bayAreaId);
        if (!siblings.length) return null;

        if (siblings.some((s) => s.id === 'smu')) {
          return 'Only one SMU can be added to this position.';
        }
        if (siblings.some((s) => s.id === 'stowage')) {
          return 'Only one Misc. Stowage can be added to this position.';
        }

        const hasFullCart = siblings.some((s) => s.id === 'full');
        const halfCartCount = siblings.filter((s) => s.id === 'half').length;

        if (hasFullCart) {
          return 'This position already has a Full Cart — only one Full Cart is allowed here.';
        }
        if (halfCartCount >= 2) {
          return 'This position already has 2 Half Carts — no more can be added.';
        }
        if (addingCartType === 'fullCart' && halfCartCount > 0) {
          return 'This position already has Half Cart(s) — a Full Cart cannot be added here.';
        }

        return null;
      }

      const onSaveGalleyLoading = async () => {
        const { id: aircraftTypeId } = selectedGalley;
        const currentGalleyObj = galleyArr.find((ar) => ar.name === (galleyIndex || initTab));
        if (!aircraftTypeId || !currentGalleyObj) {
          console.log('[onSaveGalleyLoading] aborted early — missing aircraftTypeId or currentGalleyObj', { aircraftTypeId, currentGalleyObj });
          return;
        }
        const galleyId = currentGalleyObj._id;
        const basePath = `galley/aircraftTypes/${aircraftTypeId}/galleys/${galleyId}`;
      
        setIsSaving(true);
        try {

          for (const bayId of deletedBayIds) {
            await DFPAPIEndpointGalley.delete(`${basePath}/bayAreas/${bayId}`);
          }
       
          for (const { bayAreaId, trolleyId } of deletedTrolleyIds) {
            if (deletedBayIds.includes(bayAreaId)) continue;
            await DFPAPIEndpointGalley.delete(`${basePath}/bayAreas/${bayAreaId}/trolleys/${trolleyId}`);
          }

          const idRemap = {};
          const updatedGalleyBoxes = [];
          for (const bay of galleyBoxes) {
            const positionPayload = {
              x: (bay.xPct || 0) / 100,
              y: (bay.yPct || 0) / 100,
              width: (bay.widthPct || 0) / 100,
              height: (bay.heightPct || 0) / 100,
            };
            if (bay.isNew) {
              const resp = await DFPAPIEndpointGalley.post(`${basePath}/bayAreas`, {
                name: bay.name,
                position: positionPayload,
              });
              const realId = resp?.data?._id;
           
              idRemap[bay.id] = realId;
              updatedGalleyBoxes.push({ ...bay, id: realId, isNew: false });
            } else {
              await DFPAPIEndpointGalley.put(`${basePath}/bayAreas/${bay.id}`, {
                name: bay.name,
                position: positionPayload,
              });
              updatedGalleyBoxes.push(bay);
            }
          }
   
          const updatedBoxes = [];
          for (const trolley of boxes) {
            const realBayId = idRemap[trolley.boxId] || trolley.boxId;
            const payload = {
              id: trolley.id,
              name: trolley.name,
              quantity: trolley.quantity || 1,
              code: trolley.code,
              cartQuantityAllots: trolley.cartQuantityAllots,
 
              ...(trolley.crewPositionByHalf
                ? {
                    crewPositionByHalf: trolley.crewPositionByHalf,
                    crewPositions: [
                      trolley.crewPositionByHalf.leftHalf || '',
                      trolley.crewPositionByHalf.rightHalf || '',
                    ],
                  }
                : { crewPositions: trolley.crewPositions || [] }),
            };
            if (trolley.isNew) {
              const resp = await DFPAPIEndpointGalley.post(
                `${basePath}/bayAreas/${realBayId}/trolleys`,
                payload
              );
 
              updatedBoxes.push({ ...trolley, _id: resp?.data?._id, isNew: false, boxId: realBayId, dirty: false });
            } else if (trolley.dirty) {
              await DFPAPIEndpointGalley.put(
                `${basePath}/bayAreas/${realBayId}/trolleys/${trolley._id}`,
                payload
              );
              updatedBoxes.push({ ...trolley, boxId: realBayId, dirty: false });
            } else {
              updatedBoxes.push({ ...trolley, boxId: realBayId });
            }
          }
           

          setGalleyBoxes(updatedGalleyBoxes);
          setBoxes(updatedBoxes);
          setDeletedBayIds([]);
          setDeletedTrolleyIds([]);
          setSaveGalley(true);
          setBoxId(null);
          setTabColor();
      
          setGalleyLoadinMessage({ success: 'Galley saved successfully.' });
          setSaveAlert((prev) => ({ ...prev, action: false, cancel: true }));
          if(onSaveSuccess){
            onSaveSuccess();
          }
           
        } catch (error) {
          let msg = 'Something went wrong please try again!.';
          try {
            const errMsg = JSON.parse(error?.message);
            msg = errMsg?.data?.message || msg;
          } catch (parseErr) {
           
          }
          setGalleyLoadinMessage({ error: msg });
        } finally {
          setIsSaving(false);
          setTimeout(() => {
            setSaveGalley(false);
          }, 4000);
        }
      };


  useEffect(() => {
    if(galleyDetails){
        const actModel= galleyDetails.reduce(
        (acc, item, index) => [
        ...acc,
        { key: index + 1, label: `${(item?.key || item?.code || item?.id || 'Aircraft').replace(/-+/g, '-')}`, value:item?.key || item?.code || item?.id },
        ],
        [{ key: 0, label: "Select Aircraft Variant", value: "" }]
        );

        if(actModel.length ){
        setAircraftOptions({key:actModel});

        }
    }
  }, [galleyDetails])

 useEffect(() => {
  if(galleyIndex || initTab) {
    setBoxId(null);
    
    const specGal = galleyDetails.find((g,index) => 
      (g?.key || g?.code || g?.id) === (selectedGalley?.key || selectedGalley?.code || selectedGalley?.id)
    )?.galleys;
    
    setGalleyCarts(specGal);

    const currentGalleyName = galleyIndex || initTab;
    const matchedGalley = galleyArr.find(x => x.name === currentGalleyName);
   
    getGalleyTabs();

    if (currentGalleyName) {
      setImageGalley(resolveGalleyLayoutImage(matchedGalley, currentGalleyName));
    }
  }
},  [galleyIndex, initTab, aircraftSwitchToken, galleyArr, toggleState]) 

 
  useEffect(() => {
    if (!(galleyIndex || initTab)) return;
 
    const fetchedTrolleys = galleyCartsDet.map((tr) => ({ ...tr, isNew: Boolean(tr.isNew) }));
    setBoxes(fetchedTrolleys);
 
    const hydratedBays = galleyBayAreasRaw.map((ba, i) => {
      const siblingTrolleys = ba.trolleys || [];
      const firstType = siblingTrolleys[0]?.id;
      const pos = ba.position || {};
      const hasPos = pos.x !== undefined && pos.y !== undefined;
      const col = i % 4;
      const row = Math.floor(i / 4);
      return {
        id: ba._id,
        isNew: Boolean(ba._legacy),
        name: ba.name || '',
        cartOptions: firstType ? cartOptionsFromBoxType(firstType) : '1',
        xPct: hasPos ? Number(pos.x) * 100 : (5 + col * 20),
        yPct: hasPos ? Number(pos.y) * 100 : (5 + row * 18),
      
        widthPct: pos.width !== undefined ? Number(pos.width) * 100 : 22,
        heightPct: pos.height !== undefined ? Number(pos.height) * 100 : 16,
      };
    });
 
    setGalleyBoxes(hydratedBays);
  }, [galleyCartsDet, galleyBayAreasRaw, galleyIndex, initTab])

  useEffect(() => {
        if(galleyDetails&&galleyDetails.length && selectedGalley){
 
      const specGal=galleyDetails.find((g)=>(g?.key || g?.code || g?.id)===(selectedGalley?.key || selectedGalley?.code || selectedGalley?.id))?.galleys
 
      setGalleyCarts(specGal)
    }
  }, [saveGalley,galleyDetails,selectedGalley])




  useEffect(() => {
    if (galleyCarts && galleyCarts.length) {
 
      
      galleyCarts?.forEach((gc) => {
          if (gc.name === (galleyIndex || initTab)) {
 
            const bayAreasRaw = gc.bayAreas || [];
            const legacyCarts = gc.carts || [];
            if (bayAreasRaw.length > 0) {
 
              setGalleyBayAreasRaw(bayAreasRaw);
              const flat = bayAreasRaw.flatMap((ba) =>
                (ba.trolleys || []).map((tr) => ({
                  ...tr,
                  boxId: ba._id,
                  bayAreaName: ba.name,
                  index: gc.name,
                  isNew: false,
                }))
              );
 
              setGalleyCartsDet(flat);
            } else if (legacyCarts.length > 0) {
              const legacyPositioned = legacyCarts.filter((c) => c.boxId);
              const syntheticBayAreas = legacyPositioned.map((c) => ({
                _id: c.boxId,
                name: c.code || '',
                position: null, 
                trolleys: [c],
                _legacy: true,
              }));
              setGalleyBayAreasRaw(syntheticBayAreas);
              const flat = legacyPositioned.map((c) => ({
                ...c,
                boxId: c.boxId,
                bayAreaName: c.code || '',
                index: gc.name,
                isNew: true,
              }));
              setGalleyCartsDet(flat);
            } else {
      
              setGalleyBayAreasRaw([]);
              setGalleyCartsDet([]);
            }
          }
      });
    }

  }, [galleyCarts,galleyIndex,initTab,saveGalley])

  useEffect(() => {
    if(galleyCartsDet){
      const counts = { fullCart: 0, halfCart: 0, smu: 0, stowage: 0 };
      galleyCartsDet.forEach((tr) => {
        if (tr.id === 'full') counts.fullCart++;
        else if (tr.id === 'half') counts.halfCart++;
        else if (tr.id === 'smu') counts.smu++;
        else if (tr.id === 'stowage') counts.stowage++;
      });
      setCartsGalleyLoading([{ ...counts, index: (galleyIndex || initTab) }]);
    const indices = [...new Set(cartsGalleyLoading.map(item => item.index))];
    indices.forEach(ele => {
      setCartsGalleyLoading(( currentValue ) => [ ...currentValue, cartsGalleyLoading.findLast((element) => element.index === ele) ])
    })
    }
  }, [galleyCartsDet,saveGalley])


  useEffect(() => {
    if(galleyArr&&galleyArr.length){
     const firstTabName = galleyArr[0].name;
     setInitTab(firstTabName)
    galleyArr.forEach((el) => {
      el.saved = false;
    });
   getGalleyTabs();
   const newCartsCon = galleyArr.map((gl) => {
    const userDefinedCarts = gl.galleyCartConfig?.userDefined?.map((ct) => {
      return { ...ct };
    });

    return {...userDefinedCarts, index: gl.name };
  });
  const resArr=[];

  newCartsCon.forEach((item, index) => {
  const modObj = {};
    for(let c in item){
      if (item.hasOwnProperty(c)) {

     if(item[c].hasOwnProperty('full')){

      modObj['fullCart'] = item[c].full;

     }
     else if(item[c].hasOwnProperty('half')){
      modObj['halfCart'] = item[c].half;
     }
     else if(item[c].hasOwnProperty('smu')){
      modObj['smu']=item[c].smu;
     }
    else if(item[c].hasOwnProperty('stowage')){
      modObj['stowage']=item[c].stowage;
    }
    else if(typeof item[c]==='string'){
      modObj['index']=item[c];
    }
      }
    }
    resArr.push(modObj);
  });
  setCartsCon((_)=>{return[..._,...resArr]})
    setGalleyIndex(firstTabName);
    } else {
      setGalleyIndex(initTab);
    }
  }, [galleyArr])

  const isCartLimitReached = (cartType) => {
  if (!cartsMax || !cartsCheck) return false;
  return (cartsCheck[cartType] ?? 0) >= (cartsMax[cartType] ?? 0);
};


useEffect(() => {
  if (!resolvedCartOptions) return;

  const isEditingExistingCart = Boolean(Object.keys(editGalley).length);
  if (isEditingExistingCart) {
    setCartsLimitMessage(null);
    return;
  }

  const reached = isCartLimitReached(resolvedCartOptions);

  if (reached) {
    setCartsLimitMessage(
      `Maximum limit to add ${
        resolvedCartOptions === 'fullCart'
          ? 'full cart'
          : resolvedCartOptions === 'halfCart'
          ? 'half cart'
          : resolvedCartOptions
      } has reached.`
    );
  } else {
    setCartsLimitMessage(null);
  }
}, [resolvedCartOptions, cartsCheck, cartsMax, editGalley]);


  const onAircraftChange=(e,ac=null)=>{
    setAircraftLoadingSel((prev)=>{return {...prev, key: e?.value}});
    setAircraftSwitchToken((t) => t + 1);

  const galleySelected=galleyDetails.find(gl=>(gl?.key || gl?.code || gl?.id)===e?.value) || null

  if(galleySelected && galleySelected?.galleys?.length){
    setSelectedGalley(galleySelected)
    setGalleyArr(galleySelected.galleys);
    getGalleyLists(galleySelected.galleys);

    if (!autoSelectGalley) {
      toggleTab(galleySelected?.galleys[0]?.name);
    }
  }
  else {
    setSelectedGalley(null);
    setGalleyArr([]);
    getGalleyLists([]);
    toggleTab(null);
  }
  }
const onChangeBoxName=(e,id)=>{

  setBoxId(id);
setGalleyBoxes(galleyBoxes.map(g=>{if(g.id===id){
  g.name=e.target.value
}
return g
}))
}

const onClickAddCart=(e,id)=>{
  if(e.target.alt==="GalleyAdd" && createGalleyDesign){
    if (getBoxCapacityError(id, null)) {
     
      return;
    }
    setShowAddTrolley({trolleyNo:id});
    setEditgalley({})
    let editAddFieldsDep=[];
   galleyItems&& galleyItems.map( (fieldValue, index) => {
    editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
    return fieldValue;
    });
    setTrolleyItems(editAddFieldsDep);

    EditFormFields.map( editRow => {

    if (editRow.attribute === 'trolleyItem' && editGalleyDesign ) {
    editRow.options = trolleyItems;
    }
    return editRow;
    });
  }

}
  const onClickRemoveCart=(e,id,trolleyId)=>{

  if(e.target.alt==="GalleyRemove" && deleteGalleyDesign){
    const trolley = boxes.find(b => b.boxId === id && b._id === trolleyId);
 
    if (trolley && !trolley.isNew) {
      setDeletedTrolleyIds((prev) => [...prev, { bayAreaId: id, trolleyId: trolley._id }]);
    }
    setBoxes((prev) => prev.filter((b) => b._id !== trolleyId));
  }
  }

    const onClickEditCart=(e,id,trolleyId)=>{
    if(!e.target.alt){
    setShowAddTrolley({trolleyNo:id});
    const trolley=boxes.find(b => b.boxId === id && b._id === trolleyId);
    if(trolley){
    const cfg = trolley.cartQuantityAllots?.[0] || {};
 
    setEditgalley({
      ...trolley,
      id,
      code: cfg.code || trolley.code,
      typesOfItems: cfg.typesOfItems,
      cartType: cfg.cartType,
    });
    }
    let editAddFieldsDep=[];
    galleyItems&& galleyItems.map( (fieldValue, index) => {
    editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
    return fieldValue;
    });
    setTrolleyItems(editAddFieldsDep);

    EditFormFields.map( editRow => {

    if (editRow.attribute === 'trolleyItem' ) {
    editRow.options = trolleyItems;
    }
    return editRow;
    });
    }
    }

const showGalleyLoading=()=>{
  const isLateralGalleyImage = imageGalley === lateralGalley || (typeof imageGalley === 'string' && imageGalley.includes('lateralGalley'));

  return(
    <>
    {
      <>
        <ToastContainer/>
        <div className='flexRow margBot10 margTop8' style={{ width: '100%' }}>
        <div className='alignItemsCenter' style={{ width: '100%' }}>
        <div className="container-fluid first" style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
        <div className="row tab-pane" style={{ width: '100%', margin: 0 }}>
        <div className="col-12" style={{ width: '100%', maxWidth: '100%', paddingLeft: 0, paddingRight: 0 }}>
        {!airCraftLoadingSel?.key?.includes('Select Aircraft')&& galleyArr.length!==0?<>
        <a className="d-block image-block">
        {imageGalley&& viewDetailsGalleyDesign &&
        <div
          ref={imageContainerRef}
          className="galley-container-wrapper"
          style={{
            position: 'relative',
            display: 'block',
            width: '100%',
            maxWidth: '100%',
          }}
        >
        <img
          className="Images_galley_ak"
          src={imageGalley}
          alt='Galley'
          style={isLateralGalleyImage ? {
            display: 'block',
            width: '100%',
            minWidth: '100%',
            maxWidth: '100%',
            height: '68vh',
            maxHeight: '68vh',
            aspectRatio: 'unset',
            objectFit: 'fill',
          } : {
            display: 'block',
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
          onLoad={() => {
            if (imageContainerRef.current) {
              setContainerSize({
                width: imageContainerRef.current.offsetWidth,
                height: imageContainerRef.current.offsetHeight,
              });
            }
          }}
        />
        {containerSize.width > 0 && galleyBoxes.map((_,index) => {
        const boxWidthPx = pctToPx(_.widthPct, containerSize.width);
        const boxHeightPx = pctToPx(_.heightPct, containerSize.height);
        const boxXPx = pctToPx(_.xPct, containerSize.width);
        const boxYPx = pctToPx(_.yPct, containerSize.height);
        return (
        <Rnd
          key={_.id}
          size={{ width: boxWidthPx, height: boxHeightPx }}
          position={{ x: boxXPx, y: boxYPx }}
          bounds="parent"
          minWidth={80}
          minHeight={60}
          disableDragging={!createGalleyDesign}
          enableResizing={createGalleyDesign}
          cancel=".edit_input_galley, .galley_icons_add, .cart-display, .galley-icons"
          onDragStop={(e, d) =>
            updateBayGeometry(_.id, { x: d.x, y: d.y, width: boxWidthPx, height: boxHeightPx })
          }
          onResizeStop={(e, dir, ref, delta, pos) =>
            updateBayGeometry(_.id, {
              x: pos.x,
              y: pos.y,
              width: ref.offsetWidth,
              height: ref.offsetHeight,
            })
          }
          className="ImageArea"
        >
        <div id={_.id}
        onClick={(e)=>onClickBox(e,_.id)}
        className="sm-scrollbar"
        style={{ width: '100%', height: '100%', overflowY: 'auto' }}
        >
<div className="flexRow justifyContentSpaceBetween">
<label htmlFor={'boxNames'} style={{ position: 'relative', width: '55%' }}>
  <input
    id={'boxNames'}
    name='carrierCode'
    onChange={(e) => onChangeBoxName(e, _.id)}
    value={_.name}
    style={{ borderRadius: '5px', width: '100%',padding:'0.5rem' }}
    type={'text'}
    placeholder={"Id"}
    className='edit_input_galley'
  />
</label>
<div className="flexRow" style={{ gap: '0.3rem' }}>
{createGalleyDesign?(() => {
  const atCapacity = Boolean(getBoxCapacityError(_.id, null));
  return (
    <img
      className={`galley_icons_add ${imageGalley?.includes('rearGalleyG4E') ? 'akasaGalleyFull' : 'akasaGalleyHalf'}`}
      src={plus}
      onClick={atCapacity ? undefined : (e) => onClickAddCart(e, _.id)}
      alt='GalleyAdd'
      title={atCapacity ? 'Maximum carts already added to this position' : "Add Cart"}
      style={atCapacity ? { opacity: 0.35, cursor: 'not-allowed', pointerEvents: 'none' } : undefined}
    />
  );
})():<></>}
</div>
</div>

<div className='galley_box flexCol'>
       { showCartDesign(
          boxes.filter((b) => b.boxId === _.id && b.index === (galleyIndex||initTab)),
          _.id
        )}
        </div>
        </div>
{deleteGalleyDesign ? (
  <img
    className="galley-icons bay-remove-icon"
    src={minusTot}
    onClick={() => handleRemoveBay(_.id)}
    alt="RemoveBay"
    title="Remove Bay"
  />
) : null}
        </Rnd>
        )
        })
        }
        </div>
        }
        </a></>:<div style={{width:'270px',top:'35vh',left:'35vh'}} className="image-block">No Galleys Found !</div>}
        </div>
        </div>
       </div>

    </div>

    </div>
    <div>
    </div>

      </>
    }
    {showAddTrolley?.trolleyNo.length>0 && (
        <GalleyLoadingModal
        key={showAddTrolley?.trolleyNo}
        trolleyName={showAddTrolley?.trolleyNo}
        imageGalley={imageGalley}
        presetCartOptions={galleyBoxes.find(b => b.id === showAddTrolley.trolleyNo)?.cartOptions}
        onCartOptionsResolved={(value) => setResolvedCartOptions(value)}
        cartsLimitMessage={cartsLimitMessage}
        title={titleEdit}
        airlines={domainNGo}
        galleyCarts={galleyCarts}
        editGalley={editGalley}
        galleyCartsDet={galleyCartsDet}
        tab={galleyIndex||initTab}
        trolleyItems={trolleyItems||[]}
        displayItems={displayItems}
        cartsGalleyLoading={cartsGalleyLoading}
        setGalleyCarts={setGalleyCarts}
        onClose={()=>onCloseAddGalley()}
        onSubmit={onSubmitGalleyBoxes}
        />
      )
   }

  </>)
}

const getGalleyTabs=()=>{

  const res=galleyArr.map((gl,index)=>{
    return( <React.Fragment key={index}>
      <button style={{width:'180px',marginTop:'0.95rem',marginBottom: '1.5rem'}}
      className={(toggleState||initTab)===gl.name &&!gl.saved? "tabs active-tabs" :(toggleState||initTab)===(gl.name||initTab)&&(gl.saved)? "tabs  active-tabs active-tabs-save":gl.saved?"tabs active-tabs-save":"tabs"}
      onClick={() => toggleTab(gl.name)}
      >
      { gl.name}
      </button> 
       </React.Fragment>
    )
}
)
return res

}

const getCartDetails = () => {
  if (!galleyCartsDet) return null;

  return (
    <div className="flexCol" style={{ overflowX: 'auto', paddingRight: '16px' }}>
      <button
        style={{ width: '1rem', marginTop: '1rem', marginRight: '16px' }}
        className={
          saveGalley || isSaving
            ? 'save-button-galley subheading-text-medium-title fontLight button_inrt'
            : 'save-button-galley subheading-text-medium-title fontLight'
        }
        disabled={isSaving}
        onClick={onSaveGalleyLoading}
      >
        {isSaving ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};


const getTabContents=()=>{
    return((toggleState||initTab)&&(galleyIndex||initTab) &&(toggleState||initTab )=== (galleyIndex||initTab)?
    <div className={(toggleState||initTab) === (galleyIndex||initTab) ? "content_default  active-content" : "content_default"}>
      <>
      {showGalleyLoading()}
      </>
    </div>:<></>)

}

  const toggleTab = (index) => {
  setToggleState(index);
  setGalleyIndex(index)
  setInitTab(index);
  };


  return (
    <div>
    <div className="flexCol" style={{overflowY: 'auto', height:"100%", padding:'16px' }}>
    <div
      className="flexRow alignItemsCenter"
      style={{
        gap: '12px',
        flexWrap: 'nowrap',
        marginBottom: '24px',
        paddingBottom: '12px',
        width: '100%',
        minHeight: 40,
        alignItems: 'center',
      }}
    >
      <label className='reqm' style={{ margin: 0, whiteSpace: 'nowrap' }}>Aircraft Variant :</label>
      {!aircraftOptions?.key?.length ? (
        <img src={LoadingGIF} style={{ width: '16px', height: '16px' }} alt="Loading" />
      ) : (
        <CustomSelect
          options={aircraftOptions?.key}
          controlStyle={{
            border: "1px solid rgba(40,80,140,0.45)",
            borderRadius: 50,
            minHeight: 40,
            height: 40,
            padding: 0,
          }}
          placeHolder="Select Aircraft Variant"
          width={'13rem'}
          isDisabled={true}
          value={aircraftOptions?.key?.filter(option=> option.label === airCraftLoadingSel.key)}
          onChange={onAircraftChange}
        />
      )}
      {createGalleyDesign && !airCraftLoadingSel?.key?.includes('Select Aircraft') && galleyArr.length !== 0 ? (
        <>
          <input
            type="text"
            placeholder="Enter Bay Name"
            value={newBayName}
            onChange={(e) => setNewBayName(e.target.value)}
            className='edit-input trollyQtyInp'
            style={{
              width: '10.5rem',
              height: 40,
              minHeight: 40,
              margin: 0,
              padding: '0 14px',
              borderRadius: 50,
              boxSizing: 'border-box',
              lineHeight: '40px',
            }}
          />
          <select
            value={newBayCartOptions}
            onChange={(e) => setNewBayCartOptions(e.target.value)}
            className='select-input-galley1'
            style={{
              width: '11rem',
              height: 40,
              minHeight: 40,
              margin: 0,
              padding: '0 14px',
              borderRadius: 50,
              boxSizing: 'border-box',
              lineHeight: '40px',
            }}
          >
            <option value="1">SMU</option>
            <option value="2">Full / Half Cart</option>
            <option value="0">Misc. Stowage</option>
          </select>
          <button
            className="add-role-button"
            disabled={!newBayName.trim()}
            onClick={handleCreateBay}
            title="Create a new bay and drag it into place on the image"
            style={{
              margin: 0,
              height: 40,
              width: 40,
              minWidth: 40,
              maxWidth: 40,
              padding: 0,
              borderRadius: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdOutlineAddRoad/>
          </button>
        </>
      ) : null}
    </div>

    <div className="flexRow" style={{overflowY: 'auto', flex: 1, minHeight: 0 }}>
    <div className="bloc-tabs width20Galley column-trolley" style={{ paddingRight: '20px' }}>
    <div className="flexRow width100 margBot10">
                <div className="alignItemsCenter">

                  <div className="bloc-tabs-trolley">
                  {!airCraftLoadingSel?.key?.includes('Select Aircraft')&&galleyArr&&galleyArr.length? <>
                    {getGalleyTabs()}
                  </>:<></>}
                  </div>

                    {!airCraftLoadingSel?.key?.includes('Select Aircraft')&&(galleyIndex||initTab)&&galleyArr.length ?(getCartDetails()):null}
                </div>
              </div>
    </div>
    <div style={{display:'flex',width:'80%',overflowY:'scroll'}}>
    {!airCraftLoadingSel?.key?.includes('Select Aircraft')&& getTabContents()}
    </div>
        <button 
    className="modal-close"
    onClick={onClose}
    style={{ 
      position: 'absolute',
      top: '12px',
      right: '12px',
      fontSize: '28px',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      zIndex: 1001
    }}
    >
    ×
    </button>
    </div>
    </div>
    {
    !ready &&<div className='overlay_hide sub'></div>
    }
    </div>
  );
}

